import { render, staticRenderFns } from "./ObjectiveCard.vue?vue&type=template&id=38164f74&scoped=true&"
import script from "./ObjectiveCard.vue?vue&type=script&lang=js&"
export * from "./ObjectiveCard.vue?vue&type=script&lang=js&"
import style0 from "./ObjectiveCard.vue?vue&type=style&index=0&id=38164f74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38164f74",
  null
  
)

export default component.exports